import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationStart, Router} from '@angular/router';
import {ThemePalette} from '@angular/material/core';
import {ProgressSpinnerMode} from '@angular/material/progress-spinner';
import {Session} from '../../../interfaces/session-data';
import {BankOptions} from '../../../interfaces/bank-options';
import {SecureEftService} from '../../../services/secure-eft/secure-eft.service';
import {EftPaymentResponse, EftSecureToken} from 'src/app/interfaces/secure-eft/EftSecureToken';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {Observable, throwError} from 'rxjs';
import {Actions, ofActionDispatched, Select, Store} from '@ngxs/store';
import {SetPaymentKey, SetPaymentStepSecureEft} from '../../shared/map.actions';
import {catchError, filter} from 'rxjs/operators';
import {MapState, MapStateModel, PaymentKeyState} from '../../shared/map.state';
import {HttpErrorResponse} from '@angular/common/http';

@Component({
  selector: 'app-eft',
  templateUrl: './eft.component.html',
  styleUrls: ['./eft.component.scss']
})
export class EftComponent implements OnInit {

  paymentOptionsLoadedJustify;

  // ngxs-store
  @Select(PaymentKeyState) paymentkey$: Observable<object>;
  @Select(MapState) sessionStorage$: Observable<object>;

  // box-shadow
  public boxShadow = '0px 6px 12px 0px rgba(0,0,0,0.5 )';

  // listen for state change

  // Loader
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'determinate';
  value = 50;
  diameter = 75;
  transactionChargeSent: Boolean = false;
  headerColor;
  mobile = false;
  tablet = false;
  smallDesktop = false;

  // session
  sessionData: Session;

  // payment
  paymentMethod: string;
  paymentConfirm: Boolean = false;
  paymentOptions: BankOptions;
  paymentMethodBackground = '';
  paymentMethodLogo = '';
  paymentMethodImg = '';

  // secure-eft payment interface
  eftPaymentResponse: EftPaymentResponse;

  // bank
  bankId: number;
  bankImg: string;
  bankName: string;

  // eft-secure interface vars
  token: EftSecureToken;
  loading = true;

  public selectBank = false;
  hidePgLogo = false;

  constructor(private router: Router, private route: ActivatedRoute, private secureEftService: SecureEftService, private breakpointObserver: BreakpointObserver, private store: Store, private changeDetectorRef: ChangeDetectorRef, private actions$: Actions) {
    this.sessionData = JSON.parse(sessionStorage.getItem('sessionData'));
    this.paymentMethod = 'eft';
    this.paymentMethodImg = `../../assets/icons/Payment_Cards/svg/image_${this.paymentMethod}_step_one.png`;
    sessionStorage.setItem('selected-payment', 'eft');

    router.events
    .pipe(
      filter(
        (events) => {
          return (events instanceof NavigationStart);
        }
      )
    )
    .subscribe((events: NavigationStart) => {
      if (events.navigationTrigger === 'popstate') {
        this.router.navigate([this.sessionData.virtualRoute])
          .then((data) => {
            this.loading = false;
          });
      }
    });

    this.actions$
    .pipe(ofActionDispatched(SetPaymentStepSecureEft))
    .subscribe(({ payload }) => this.paymentMethodImg = `../../assets/icons/Payment_Cards/svg/image_${this.paymentMethod}_${payload.toLowerCase()}.png`);

    breakpointObserver.observe([
      Breakpoints.HandsetLandscape,
      Breakpoints.HandsetPortrait
    ]).subscribe((result) => {

      if (result.matches) {
        // mobile
        this.mobile = true;

      }
    });
  }

  ngOnInit(): void {
    this.headerColor = (document.getElementsByClassName('header-container')[0] as HTMLElement).style.backgroundColor;
    sessionStorage.setItem('TRANSACTION_CONFIRMED_PAYMENT_METHOD', this.paymentMethod);
    if (this.router.routerState.snapshot.url.indexOf('eft/') === -1) {
      this.sessionStorage$.subscribe((data: MapStateModel) => {
        this.sessionData = data.sessionStorage;
      });
      this.secureEftService.initializePayment(sessionStorage.getItem('sessionToken'))
        .subscribe((data: EftPaymentResponse) => {
        this.eftPaymentResponse = data;
        if (!this.eftPaymentResponse) {
          this.router.navigate(['transaction-status']);
        }
        this.hidePgLogo = this.sessionData?.sessionDisplayInformation?.hidePgLogo === 'true';
        sessionStorage.setItem('eftTransactionId', this.eftPaymentResponse.transactionId);
        sessionStorage.setItem('eftPaymentKey', this.eftPaymentResponse.eftPaymentKey);
        this.store.dispatch(new SetPaymentKey(this.eftPaymentResponse.eftPaymentKey));

       // setTimeout(() => {
        this.loading = false;
        this.router.navigate(['transaction'], { relativeTo: this.route });
       // }, 2000);
      }, (err: HttpErrorResponse) => {
          this.router.navigate(['transaction-status']);
        });
    } else {
      this.loading = false;
    }




    this.paymentkey$.pipe(
      catchError((err) => {
        return throwError(err);
      })
    );

  }

  cancelTransaction() {
    this.router.navigate(['transaction-status/userCancelled']);
  }

  goBack() {
    sessionStorage.setItem('goBack', 'true');
    return this.router.navigate(['virtual']);
  }

}
